// import GSAP
// needed for on slide change animation
import { gsap } from 'gsap';
// import Swiper JS
// import Swiper, { Autoplay, Navigation, EffectCoverflow, EffectFade, FreeMode, Thumbs } from 'swiper';
import Swiper, {Autoplay, Navigation, EffectFade, FreeMode, Parallax} from 'swiper';
// import Swiper styles
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
// import 'swiper/css/pagination';
// import 'swiper/css/effect-coverflow';
import 'swiper/css/free-mode';
import 'swiper/css/parallax';
// import 'swiper/css/thumbs';
import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

Fancybox.bind("[data-fancybox]");

let homepage = document.body.classList.contains('page-template-homepage');
// ! SLIDERS
const __simpleFullSlider = '.default__slider';
// * HOME
const homepageSlider = '.homepage__slider';
const newsSlider = '.news__slider';

// breakpoint where swiper will be destroyed
// and switches to a dual-column layout
const breakpoint = window.matchMedia( '(min-width:1141px)' );
// keep track of swiper instances to destroy later
let interiorSlider;
let outdoorSlider;
const breakpointChecker = function() {
    // if larger viewport and multi-row layout needed
    if ( breakpoint.matches === true ) {
        // clean up old instances and inline styles when available
        if ( interiorSlider !== undefined ) interiorSlider.destroy( true, true );
        if ( outdoorSlider !== undefined ) outdoorSlider.destroy( true, true );

        // else if a small viewport and single column layout needed
    } else if ( breakpoint.matches === false ) {
        // fire small viewport version of swiper
        return enableSwiper();
    }
};

const enableSwiper = function() {
    interiorSlider = new Swiper(".section__banner--interior", {
        modules: [FreeMode],
        slidesPerView: "auto"
    });
    outdoorSlider = new Swiper(".section__banner--outdoor", {
        modules: [FreeMode],
        slidesPerView: "auto"
    });
};

// keep an eye on viewport size changes
window.addEventListener('resize', breakpointChecker);

window.addEventListener('DOMContentLoaded', () => {
    if (homepageSlider) {
        breakpointChecker();
    }

    if (homepage && homepageSlider ) {
        let homepageSlider = new Swiper(".homepage__slider", {
            modules: [Autoplay, Parallax],
            parallax: true,
            speed: 1000,
            parallaxEl: {
                duration: 5000,
            },
            loop: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: true,
            },
            slidesPerView: 1,
        });
    }

    if (homepage && newsSlider ) {
        let newsSlider = new Swiper(".news__slider", {
            modules: [ Navigation],
            slidesPerView: 1.2,
            spaceBetween: 24,
            centeredSlides: true,
            initialSlide: 1,
            loop: true,
            breakpoints: {
                768: {
                    initialSlide: 0,
                    centeredSlides: false,
                    slidesPerView: 1.8
                },
                1024: {
                    centeredSlides: false,
                    slidesPerView: 3,
                    loop: false,
                }
            }
        });
    }

    jQuery('.products__gallery__slider').each( function(i , obj)  {
        new Swiper(obj, {
            modules: [Navigation],
            slidesPerView: 1.2,
            spaceBetween: 14,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                768: {
                    spaceBetween: 25,
                    slidesPerView: 1.5
                },
                992: {
                    slidesPerView: 2.4,
                    spaceBetween: 32,
                },
            },
            on: {
                slideChange: function (){
                    let x = this.wrapperEl.parentElement.parentElement.classList[1]

                    if( Array.from(document.getElementById('prev-slider-' + x).classList).includes('swiper-button-disabled') ){
                        document.querySelector('.' + x + ' .btn-prev').setAttribute('disabled', '')
                    }else{
                        document.querySelector('.' + x + ' .btn-prev').removeAttribute('disabled')
                    }

                    if( Array.from(document.getElementById('next-slider-' + x).classList).includes('swiper-button-disabled') ){
                        document.querySelector('.' + x + ' .btn-next').setAttribute('disabled', '')
                    }else{
                        document.querySelector('.' + x + ' .btn-next').removeAttribute('disabled')
                    }
                }
            },
        });
    })

    if(document.body.classList.contains('page-template-who-we-are')) {
        let whoWeAreSwiper = new Swiper(".who-we-are__gallery", {
            modules: [Autoplay],
            slidesPerView: 1.2,
            speed: 10000,
            breakpoints: {
                768: {
                    slidesPerView: 1.5
                },
                992: {
                    slidesPerView: 3.2
                },
            },
            autoplay: {
                delay: 0,
                disableOnInteraction: false
            },
            loop: true,
            freeMode: false,
            freeModeMomentum: false,
            grabCursor: false,
            allowTouchMove: false,
            simulateTouch: false
        })
    }

    if(document.body.classList.contains('single')) {
        let whoWeAreSwiper = new Swiper(".single__gallery", {
            modules: [Autoplay],
            slidesPerView: 1.2,
            speed: 10000,
            breakpoints: {
                768: {
                    slidesPerView: 1.5
                },
                992: {
                    slidesPerView: 3.2
                },
            },
            autoplay: {
                delay: 0,
                disableOnInteraction: false
            },
            loop: true,
            freeMode: false,
            freeModeMomentum: false,
            grabCursor: false,
            allowTouchMove: false,
            simulateTouch: false,
        })
    }
});

let childrenFadeEffect = (target) => {
    const fadeChildren = document.querySelectorAll(target);
    if (fadeChildren.length) {
        fadeChildren.forEach((el) => {
            const showTl = gsap.timeline();
            showTl.fromTo(el.children, { y: 20, opacity: 0 }, { y: 0, opacity: 1, duration: 1, stagger: 0.5, ease: 'ease' });
        });
    }
};

// Single product - Gallery slider
jQuery('.single-product__gallery').each(function(){
    const productGallerySwiper = jQuery(this).find(".single-product__gallery-slider")[0]
    const productGallerySwiperNext = jQuery(this).find(".single-product__gallery-arrows-next")[0]
    const productGallerySwiperPrev = jQuery(this).find(".single-product__gallery-arrows-prev")[0]

    new Swiper(productGallerySwiper, {
        modules: [Navigation, FreeMode],
        freeMode: true,
        slidesPerView: "auto",
        navigation: {
            nextEl: productGallerySwiperNext,
            prevEl: productGallerySwiperPrev,
        }
    })
})

// Single product - Projects slider
jQuery('.single-product__portfolio').each(function(){
    const projectsSwiper = jQuery(this).find(".single-product__portfolio-gallery")[0]
    const projectsSwiperNext = jQuery(this).find(".single-product__portfolio-arrows-next")[0]
    const projectsSwiperPrev = jQuery(this).find(".single-product__portfolio-arrows-prev")[0]

    new Swiper(projectsSwiper, {
        modules: [Navigation],
        slidesPerView: 1.2,
        spaceBetween: 14,
        navigation: {
            nextEl: projectsSwiperNext,
            prevEl: projectsSwiperPrev,
        },
        breakpoints: {
            768: {
                spaceBetween: 25,
                slidesPerView: 1.5
            },
            992: {
                slidesPerView: 2.4,
                spaceBetween: 32,
            },
        },
    })
})


